module.exports = __webpack_public_path__ + "img/notification.6a5b34ef.png";